<template>
  <div>
    <a
      class="link_pdf"
      :href="item.clauseUrl"
      v-for="item in clauses"
      :key="item.clauseName"
      >{{ item.clauseName }}</a
    >
  </div>
</template>

<script>
import { getTermsDetail } from '@/api/api'

export default {
  name: 'index',
  data() {
    return {
      // 条款列表
      clauses: []
    }
  },
  methods: {
    async getPdfs() {
      const { product } = await getTermsDetail({
        pid: this.$route.query.pid
      })
      const { ext: { clauses } } = product
      this.clauses = clauses
    },
    openPdf(url) {
      location.href = url
    }
  },
  created() {
    this.getPdfs()
  }
}
</script>

<style lang="less" scoped>
.link_pdf {
  display: block;
  height: 0.8rem;
  line-height: 0.8rem;
  color: #333;
  border-bottom: 0.02rem solid #ccc;
  padding-left: 0.2rem;
  box-sizing: border-box;
  font-size: 0.28rem;
}
</style>
